module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-aaf0c0dc8f68f0a9906c2fd25d51bf87.svg";